import { useQueryClient } from '@tanstack/react-query';

import {
  getApiV1LocationCountriesCountryidLangsQueryOptions,
  useDeleteApiV1LocationCountriesCountryidLangsId,
} from '@/shared/api/generated';

/**
 * Hook para remover um idioma de um país.
 *
 * Envolve o mutation gerado pelo Kubb para
 * `DELETE /api/v1/location/countries/{countryId}/langs/{id}` e invalida o cache
 * da listagem após a remoção. O `mutate` recebe `{ countryId, id }`.
 *
 * @param countryId - Id do país dono dos idiomas.
 */
export function useDeleteCountryLang(countryId: number) {
  const queryClient = useQueryClient();

  return useDeleteApiV1LocationCountriesCountryidLangsId({
    mutation: {
      onSuccess: () => {
        void queryClient.invalidateQueries(
          getApiV1LocationCountriesCountryidLangsQueryOptions(countryId),
        );
      },
    },
  });
}
